var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"animated-number"},[(_vm.formattedNumber < 10 && _vm.addZero)?_c('span',[_vm._v("0")]):_vm._e(),_c('span',[_vm._v(_vm._s(_vm.formattedNumber))]),(_vm.unit)?_c('span',[_vm._v(_vm._s(_vm.unit))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }